module.exports = __webpack_public_path__ + "img/6c659780-71e3-4ad5-9900-4be64d7a7562.24395165.png";